<app-add-form
  data-testid="transfer-add-form"
  [title]="title"
  [formFields]="formFields"
  [headerActions]="headerActions"
  (formAction)="onFormAction($event)"
></app-add-form>
